export function PageLoading(){return <div className="page-loading"><span/><span/><span/></div>}
export function PageError({message}:{message:string}){return <div className="page-message"><b>We could not load this page.</b><p>{message}</p></div>}
